"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeaheadMenu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _typeaheadList = require("./typeaheadList.style");
var _react = require("react");
var _typeahead = require("./typeahead.util");
const TypeaheadMenu = exports.TypeaheadMenu = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    onMouseEnter,
    onMouseLeave,
    maxListHeight,
    $hide,
    children
  } = props;
  //UL wrapper of typeahead
  return (0, _jsxRuntime.jsx)(_typeaheadList.Components.Wrapper, (0, _extends2["default"])({
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    maxHeight: maxListHeight ? maxListHeight : _typeahead.MAX_MATCHES * 50 + 'px',
    "$hidden": $hide,
    ref: ref
  }, {
    children: children
  }));
});